import Cookies from "js-cookie";

// ----------------------------------------------------------------------------

export type IMdtCookieData = {
  cguid: string; // A unique identifier (UUID) for the cookie
  cstamp: string; // A timestamp indicating when the cookie was set
  // category ----------
  "0001": boolean; // Essential
  "0002": boolean; // Marketing
  "0003": boolean; // Analysis
  "0004": boolean; // Functional
  "0005": boolean; // Performance
  "0006": boolean; // Unclassified
  // -------------------
  versionuid: string; // A version identifier for the cookie
  VerId: number; // A version ID number
  regcode: string; // Registration code (empty string if not set)
  locinfo: string; // Encoded location information
};

export type IMdtCookieDataKeys = Extract<keyof IMdtCookieData, string>;

export enum CookieName {
  ESSENTIAL = "Essential",
  MARKETING = "Marketing",
  ANALYSIS = "Analysis",
  FUNCTIONAL = "Functional",
  PERFORMANCE = "Performance",
  UNCLASSIFIED = "Unclassified",
  MDT_CONSENT = "Mdt_Consent",
  LATEST_E_BOOK = "latest-e-book-pop-up",
  NEWSLETTER_SUBSCRIPTION = "news-latter-subscription-pop-up",
}

const cookieCategoryID: Partial<Record<CookieName, IMdtCookieDataKeys>> = {
  [CookieName.ESSENTIAL]: "0001",
  [CookieName.MARKETING]: "0002",
  [CookieName.ANALYSIS]: "0003",
  [CookieName.FUNCTIONAL]: "0004",
  [CookieName.PERFORMANCE]: "0005",
  [CookieName.UNCLASSIFIED]: "0006",
};

const getMandatlyCategoryValue = (category: CookieName, mdtCookie?: string) => {
  if (!mdtCookie) return;

  const jsonMdtCookieData: IMdtCookieData = JSON.parse(mdtCookie);
  const categoryKey: IMdtCookieDataKeys | undefined =
    cookieCategoryID[category];

  if (!categoryKey) return;

  return jsonMdtCookieData[categoryKey];
};

export const getCookie = (cookie: CookieName) => {
  const mdtCookie = Cookies.get("Mdt_Consent");

  switch (cookie) {
    // Mandatly Cookie Category
    case CookieName.ESSENTIAL:
    case CookieName.MARKETING:
    case CookieName.ANALYSIS:
    case CookieName.FUNCTIONAL:
    case CookieName.PERFORMANCE:
    case CookieName.UNCLASSIFIED:
      return getMandatlyCategoryValue(cookie, mdtCookie);

    // Local cookies
    case CookieName.LATEST_E_BOOK:
    case CookieName.NEWSLETTER_SUBSCRIPTION:
      return Cookies.get(cookie);

    // Mandatly Cookie Object
    case CookieName.MDT_CONSENT:
      return mdtCookie;
  }
};

// True when the visitor has granted Marketing consent (Mandatly category
// 0002). This is the lawful basis for the advertising use of PII — e.g.
// forwarding a hashed email to Google Ads for Enhanced Conversions matching.
// Gate any ad-directed PII (even hashed) on this so nothing is processed for
// advertising without consent.
export const hasMarketingConsent = (): boolean =>
  Boolean(getCookie(CookieName.MARKETING));
